import React, { useEffect, useLayoutEffect, Fragment } from "react";
import { autorun } from "mobx";
import { observer, inject } from "mobx-react";
import { parse } from "qs";
import cx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import BrandCardHeader from "../../components/BrandCardHeader";
import LockIcon from "@material-ui/icons/Lock";
import CardContent from "@material-ui/core/CardContent";
import { useOverShadowStyles } from "@mui-treasury/styles/shadow/over";
import FormConstructor from "../../organisms/FormConstructor";
import MarkDown from "../../molecules/display/MarkDown";
import Form from "../../organisms/Form";
import { isField } from "../../utils/fieldTypes";
import newPasswordInputs from "../../utils/formFields/newPasswordInputs";
import { navigate } from "gatsby";

const useStyles = makeStyles(() => ({
  root: {
    margin: "auto",
    borderRadius: 12
  },
  media: {
    borderRadius: 6
  }
}));

const NewPasswordForm = inject("store")(
  observer(
    ({
      store,
      store: {
        forms: { newPasswordForm },
        browser: {
          browserLocation: { origin, search }
        },
        queries: { resetPasswordCode }
      }
    }) => {
      const styles = useStyles();
      const shadowStyles = useOverShadowStyles({ inactive: true });

      const handleNewPasswordCode = () => {
        if (origin) {
          const successQuery = search
            ? parse(search, { ignoreQueryPrefix: true })
            : { code: null };
          const { code } = successQuery;
          if (code) {
            return store.setQuery("resetPasswordCode", code);
          }

          return navigate("/change-password");
        }
      };

      useEffect(() => {
        if (!newPasswordForm) {
          const form = new FormConstructor(
            {
              fields: newPasswordInputs.filter(field => isField(field.type))
            },
            { name: "newPasswordForm" }
          );
          store.setForm("newPasswordForm", form);
        }
      }, [newPasswordForm]);

      useLayoutEffect(() => autorun(() => handleNewPasswordCode()));

      return (
        <Fragment>
          {resetPasswordCode && newPasswordForm && newPasswordInputs && (
            <Card className={cx(styles.root, shadowStyles.root)}>
              <BrandCardHeader
                extra={"Set Your New Password"}
                avatarIcon={<LockIcon />}
              />
              <CardContent>
                <Form
                  fields={newPasswordInputs}
                  form={newPasswordForm}
                  buttonProps={{
                    color: "primary",
                    fullWidth: true,
                    variant: "contained"
                  }}
                />
              </CardContent>
              <CardContent>
                <MarkDown
                  source={`Did you just remember it?
              Go back to [the sign-in page](/).`}
                  variants={{ p: "body1" }}
                />
              </CardContent>
            </Card>
          )}
        </Fragment>
      );
    }
  )
);

export default NewPasswordForm;
